import { render, staticRenderFns } from "./ZXDDAllianceAuthorization.vue?vue&type=template&id=a2dc1a26"
import script from "./ZXDDAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./ZXDDAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2dc1a26')) {
      api.createRecord('a2dc1a26', component.options)
    } else {
      api.reload('a2dc1a26', component.options)
    }
    module.hot.accept("./ZXDDAllianceAuthorization.vue?vue&type=template&id=a2dc1a26", function () {
      api.rerender('a2dc1a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/ZXDDAllianceAuthorization.vue"
export default component.exports